import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from 'styled-components';
import { Button } from '../button';
export var ReadMoreButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  font-weight: 600;\n  padding: 0;\n  font-size: 14px;\n  line-height: 16px;\n\n  @media (min-width: ", ") {\n    font-size: 16px;\n    line-height: 18px;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.screen.mdMin;
});
export var TextLines = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), function (_ref2) {
  var limitText = _ref2.limitText,
      numberOfLines = _ref2.numberOfLines;
  return limitText ? numberOfLines : 'initial';
});

var positionHandler = function positionHandler(position) {
  var positionOptions = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center'
  };
  return positionOptions[position || 'left'];
};

export var ContentReadMoreButton = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n  margin-top: 8px;\n"])), function (_ref3) {
  var position = _ref3.position;
  return positionHandler(position);
});